
import { Badge } from "@/components/ui/badge";
import { MapPin, Image as ImageIcon } from "lucide-react";
import { Investment } from "@/types/investment";

interface InvestmentCardHeaderProps {
  investment: Investment;
}

const InvestmentCardHeader = ({ investment }: InvestmentCardHeaderProps) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case "Open for Bidding":
        return "bg-green-100 text-green-800";
      case "Under Review":
        return "bg-yellow-100 text-yellow-800";
      case "Sold":
        return "bg-gray-100 text-gray-800";
      default:
        return "bg-blue-100 text-blue-800";
    }
  };

  return (
    <div>
      {/* Property Image */}
      <div className="mb-4">
        {investment.thumbnail_image ? (
          <img 
            src={investment.thumbnail_image} 
            alt={investment.propertyAddress || investment.location}
            className="w-full h-48 object-cover rounded-lg"
          />
        ) : (
          <div className="w-full h-48 bg-gray-100 rounded-lg flex items-center justify-center">
            <div className="text-center text-gray-400">
              <ImageIcon className="h-8 w-8 mx-auto mb-2" />
              <p className="text-sm">No image available</p>
            </div>
          </div>
        )}
      </div>

      {/* Header Content */}
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            {investment.type}
          </h3>
          <div className="flex items-center text-gray-600 mb-2">
            <MapPin className="h-4 w-4 mr-1" />
            <span className="text-sm">{investment.propertyAddress || investment.location}</span>
          </div>
        </div>
        <Badge className={getStatusColor(investment.status)}>
          {investment.status}
        </Badge>
      </div>
    </div>
  );
};

export default InvestmentCardHeader;
